/*
 * @Author: liyxt
 * @Date: 2020-05-19 15:47:39
 * @LastEditors: bbqin
 * @LastEditTime: 2021-10-14 18:10:12
 * @Description: file content
 */
import React, { Component } from 'react';
import { getSysFieldid } from '@platform/api';

require('./index.less');

export default class Input extends Component {
    constructor(props) {
        super(props);
        this.state = {
            json: {}
        };
    }
    render() {
        let { showStar, fieldid, value, className, onChange, onBlur, ...others } = this.props;
        if (!value || typeof value !== 'string') {
            value = '';
        }
        value = value && value.replace(/./g, '*');
        // return <FormControl {...this.props} />;
        return (
            <div className={`u-form-control-wrapper ${className}`} >
                {showStar ? <span className="input-required-tag">*</span> : ''}
                <input
                    fieldid={getSysFieldid(fieldid) || null}
                    className="u-form-control"
                    value={value}
                    onChange={e => {
                        onChange(e.target.value);
                    }}
                    onBlur={e => onBlur(e.target.value)}
                    {...others}
                />
            </div>
        );
    }
}
